import { ActionBar, Button } from '@components'
import { getVATPageUrl } from '@constants'
import { useBusinessContext } from '@context'
import { createVatPeriod, invalidateDashboardQueries, IVatPeriod } from '@query'
import React from 'react'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { FaPlus } from 'react-icons/fa'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useHistory } from 'react-router-dom'

export const VatActionBar: React.FC = () => {
  const [t] = useTranslation()
  const history = useHistory()
  const queryClient = useQueryClient()
  const { slug } = useBusinessContext()

  const { mutateAsync, isPending: isLoading } = useMutation<IVatPeriod>({
    mutationFn: () => createVatPeriod({ slug }, {}),
    ...{
      onSuccess: data => {
        const newVatPeriodUrl = getVATPageUrl(slug, { id: data.id })
        history.push(newVatPeriodUrl)

        queryClient.invalidateQueries({ queryKey: [slug, 'vat_periods'] })
        void invalidateDashboardQueries(queryClient, slug)
        toast.success(t('vatPage.periodCreated'))
      }
    }
  })

  const primaryButtons = [
    <Button
      key="create-button"
      icon={<FaPlus />}
      onClick={() => mutateAsync()}
      showSpinner={isLoading}
      disabled={isLoading}
    >
      {t('vatPage.createNew')}
    </Button>
  ]

  return <ActionBar primaryButtons={primaryButtons}></ActionBar>
}
